import { render, staticRenderFns } from "./PriceTwo.vue?vue&type=template&id=023ad202&scoped=true"
import script from "./PriceTwo.vue?vue&type=script&lang=js"
export * from "./PriceTwo.vue?vue&type=script&lang=js"
import style0 from "./PriceTwo.vue?vue&type=style&index=0&id=023ad202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ad202",
  null
  
)

export default component.exports